import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d5836ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-picker" }
const _hoisted_2 = {
  key: 0,
  class: "date-picker__error"
}

import VueDatePicker, { DatePickerInstance } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { ru } from 'date-fns/locale';
import { computed, onMounted, ref } from 'vue';

type FlowType = 'month' | 'year' | 'calendar';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDatePicker',
  props: /*#__PURE__*/_mergeModels({
    clearable: { type: Boolean, default: true },
    label: { default: 'Выберите дату' },
    disabled: { type: Boolean },
    required: { type: Boolean },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    flow: {},
    height: { default: '36' },
    backgroundColor: { default: '#ffffff' },
    error: {},
    withBg: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['focus', 'blur'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

// eslint-disable-next-line import/named
const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const dateValue = _useModel<string | number | null>(__props, "modelValue");

const datepicker = ref<DatePickerInstance>(null);
const tooltipActive = ref(false);
const datePickerLabel = ref<HTMLElement | undefined>();

const format = computed((): string => {
  if (props.monthPicker) {
    return 'MMMM yyyy';
  }
  if (props.yearPicker) {
    return 'yyyy';
  }

  return 'dd.MM.yyyy';
});

const cssProps = computed(() => {
  return {
    '--dp-background-color': props.backgroundColor,
    '--dp-height': props.height + 'px',
  };
});

onMounted(() => {
  if (datePickerLabel.value) {
    if (datePickerLabel.value.clientWidth < datePickerLabel.value.scrollWidth) {
      tooltipActive.value = true;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueDatePicker), {
      ref_key: "datepicker",
      ref: datepicker,
      modelValue: dateValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateValue).value = $event)),
      clearable: _ctx.clearable,
      disabled: _ctx.disabled,
      flow: _ctx.flow,
      format: format.value,
      "format-locale": _unref(ru),
      "month-picker": _ctx.monthPicker,
      style: _normalizeStyle([cssProps.value]),
      "year-picker": _ctx.yearPicker,
      "auto-apply": "",
      "model-type": "yyyy-MM-dd hh:mm:ss",
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur')))
    }, {
      "dp-input": _withCtx(({ value }) => [
        _createVNode(_component_base_input, {
          modelValue: dateValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
          label: _ctx.label,
          "with-bg": _ctx.withBg
        }, null, 8, ["modelValue", "label", "with-bg"])
      ]),
      _: 1
    }, 8, ["modelValue", "clearable", "disabled", "flow", "format", "format-locale", "month-picker", "style", "year-picker"]),
    (_ctx.error?.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})